import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFullIconSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32.002}
    height={18.001}
    data-name="Group 52"
    {...props}
  >
    <g data-name="White Box">
      <path fill="#fff" d="M31.502 17.501h-31v-17h31Z" data-name="Path 1" />
      <path fill="#024" d="M1 1v16h30V1zM0 0h32v18H0Z" data-name="Path 2" />
    </g>
    <path fill="#024" d="M2 1.999h28v14H2Z" data-name="Grey Box" />
  </svg>
);
export default SvgFullIconSmall;
